import {NonFunctionProperties} from '@colonist/types'
import {BaseError} from './BaseError'
import {ErrorTypes} from './ErrorEnums'
import {ErrorAuth, ErrorBlocking, ErrorDefault, ErrorMustBeMember, ErrorMustLogin} from './Errors'

export class ErrorController {
    static deserializeErrorData(errorData: NonFunctionProperties<BaseError>): BaseError | undefined {
        switch(errorData.type) {
            case ErrorTypes.DefaultError: return ErrorDefault.deserialize(errorData as NonFunctionProperties<ErrorDefault>)
            case ErrorTypes.AuthError: return ErrorAuth.deserialize(errorData as NonFunctionProperties<ErrorAuth>)
            case ErrorTypes.MustLogin: return ErrorMustLogin.deserialize(errorData as NonFunctionProperties<ErrorMustLogin>)
            case ErrorTypes.MustBeMember: return ErrorMustBeMember.deserialize(errorData as NonFunctionProperties<ErrorMustBeMember>)
            case ErrorTypes.Blocking: return ErrorBlocking.deserialize(errorData as NonFunctionProperties<ErrorBlocking>)
            default: return undefined
        }
    }
}
